export const accessPermissions = {
    VIEW_CAMERA_EVENTS: {
        key: 'Access.CameraEvents',
        name: 'View camera events list',
    }
}
